export default class AuthEvent extends CustomEvent {

    static login(pUser) {
        
        const authEvent = new AuthEvent({
            type: "login",
            user: pUser
        })
        
        window.dispatchEvent(authEvent)
    }

    static logout() {
        
        const authEvent = new AuthEvent({
            type: "logout"
        })
        
        window.dispatchEvent(authEvent)
    }

    constructor(p) {

        super(
            "authEvent",
            {
                detail: {
                    type: p.type,
                    user: p.user
                }
            }
        )
    }
}